import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const PLYX_API = `${BACKEND_URL}/api`;

// Plyx auth is intentionally separate from AfriMarket. Tokens stored under
// their own key so the two systems never overlap.
export const plyxApi = axios.create({ baseURL: PLYX_API, withCredentials: false });

plyxApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("plyx_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const setPlyxToken = (t) => {
  if (t) localStorage.setItem("plyx_token", t);
  else localStorage.removeItem("plyx_token");
};
export const getPlyxToken = () => localStorage.getItem("plyx_token");

// Absolute URL helper for stored media (videos / thumbs / avatars)
export const plyxMediaUrl = (relOrAbs) => {
  if (!relOrAbs) return "";
  if (/^https?:\/\//i.test(relOrAbs)) return relOrAbs;
  return `${BACKEND_URL}${relOrAbs}`;
};
